import React from 'react'

import { Helmet } from 'react-helmet'

import PagesliderSafety from '../components/pageslider-safety'
import './signs.css'

const Safety = (props) => {
  const { increaseTrainingPercentage, type } = props;

  return (
    <div className="signs-container">
      <Helmet>
        <title>Signs - ORRS</title>
        <meta property="og:title" content="Signs - ORRS" />
      </Helmet>
      <div className="home-header">
        <div className="header-content">
            <img id="logo" src="\external\ORRSLogos_1113.png" alt="Logo" />
            <h1 className="home-text">The Opioid Rapid Response System (ORRS)<sup className='trademark'>TM</sup></h1>
        </div>
    </div>
      <PagesliderSafety  type={type} increaseTrainingPercentage={increaseTrainingPercentage} rootClassName="pageslider-signs-root-class-name"></PagesliderSafety>
      <footer className="signs-footer">
        <span className="signs-text2">
          <span>
            The contents of this training were created by REAL Prevention. For
            inquiries on permission for use of these materials please contact
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="signs-text4">hechtpsu@gmail.com.</span>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </span>
        <span className="signs-text6 Content">
          Copyright (2021) REAL Prevention. All rights reserved.
        </span>
      </footer>
    </div>
  )
}

export default Safety
